const MESSAGES = {
  owner_protected: "Owner role cannot be modified except via Transfer ownership",
  self_demote_blocked: "You cannot demote yourself",
  self_suspend_blocked: "You cannot suspend yourself",
  last_admin_blocked: "Cannot demote the only remaining admin",
  email_taken: "That email is already in use",
  user_not_active: "Password reset is not available for deactivated users",
  user_not_found: "User not found",
  invalid_reassign_target: "Selected user is no longer available for reassignment. Try another.",
  already_deactivated: "User is already deactivated",
  must_deactivate_first: "User must be deactivated before deletion",
  self_deactivate_blocked: "You cannot deactivate yourself",
  self_delete_blocked: "You cannot delete yourself",
  invalid_body: "Please check the form and try again.",
  kratos_error: "Identity provider request failed. Try again.",
  same_owner: "You are already the owner. Select a different recipient.",
  invalid_recipient: "Recipient must be an active administrator.",
  confirmation_mismatch: "Email confirmation does not match the recipient's email.",
};

export function mapAdminError(code) {
  const key = String(code || "").trim();
  if (MESSAGES[key]) return MESSAGES[key];
  return "Request failed. Try again.";
}

export async function readApiError(res, fallback = "Request failed") {
  try {
    const body = await res.json();
    if (body?.error) return mapAdminError(body.error);
    return fallback;
  } catch {
    return fallback;
  }
}
